module.exports = __webpack_public_path__ + "static/media/030.e5b45f10.png";